import markItemsJunkNotJunkFromTable from './helpers/markItemsJunkNotJunkFromTable';
import markConversationsJunkNotJunkFromTable from './helpers/markConversationsJunkNotJunkFromTable';
import { TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Mark the rows as junk or not junk
 * @param rowKeys of the rows to be marked as junk/not junk
 * @param tableView that contains the rows
 * @param isJunkValueToSet whether to mark as junk or not junk
 * @param actionSource the action source
 */
export default function markRowsJunkNotJunkFromTable(
    rowKeys: string[],
    tableView: TableView,
    isJunkValueToSet: boolean,
    actionSource: ActionSource
) {
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            markConversationsJunkNotJunkFromTable(
                rowKeys,
                tableView,
                isJunkValueToSet,
                actionSource
            );
            break;

        case ReactListViewType.Message:
            markItemsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
    }
}
